import {t} from '../../../common/getTranslations';
import {TicketTypeVo} from '../../../common/shared/api/nicolas/vo/TicketTypeVo.enum';

export function getTicketTitle(ticketType: TicketTypeVo): string {
  let ticketTitle = '';
  switch (ticketType) {
    case TicketTypeVo.BuyNewCustomerGift:
      ticketTitle = t('common_ticket_possession_new');
      break;
    case TicketTypeVo.BuySingle:
    case TicketTypeVo.BuyPackage:
      ticketTitle = t('common_ticket_possession');
      break;
    case TicketTypeVo.BuyEvent:
    case TicketTypeVo.BuyCoupon:
      ticketTitle = t('common_ticket_possession_free');
      break;
    case TicketTypeVo.BuyWaitFree:
      ticketTitle = t('common_ticket_possession_wuf');
      break;
    case TicketTypeVo.BuyTodayGift:
      ticketTitle = t('common_ticket_possession_gift');
      break;
    case TicketTypeVo.BuyGiftFree:
      ticketTitle = t('common_ticket_possession_free');
      break;
    case TicketTypeVo.BuyMoviePpv:
      ticketTitle = t('common_ticket_possession');
      break;
    case TicketTypeVo.BuyCampaign:
      ticketTitle = t('common_ticket_possession_free');
      break;
    case TicketTypeVo.RentNewCustomerGift:
      ticketTitle = t('common_ticket_rental_new');
      break;
    case TicketTypeVo.RentSingle:
    case TicketTypeVo.RentPackage:
      ticketTitle = t('common_ticket_rental');
      break;
    case TicketTypeVo.RentEvent:
      ticketTitle = t('common_ticket_rental_free');
      break;
    case TicketTypeVo.RentCoupon:
      ticketTitle = t('common_ticket_rental_free');
      break;
    case TicketTypeVo.RentWaitFree:
      ticketTitle = t('common_ticket_rental_wuf');
      break;
    case TicketTypeVo.RentTodayGift:
      ticketTitle = t('common_ticket_rental_gift');
      break;
    case TicketTypeVo.RentGiftFree:
      ticketTitle = t('common_ticket_rental_free');
      break;
    case TicketTypeVo.RentMoviePpv:
      ticketTitle = t('common_ticket_rental');
      break;
    case TicketTypeVo.RentCampaign:
      ticketTitle = t('common_ticket_rental_free');
      break;
    default:
      ticketTitle = ticketType.startsWith('TT')
        ? t('common_ticket_possession')
        : t('common_ticket_rental');
      break;
  }

  return ticketTitle;
}
